import { Fragment } from 'react'
import { CommentForm } from './CommentForm'
import { Box, Divider } from '@mui/material'
import { CommentsList } from './CommentsList'

export const Comments = () => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%', minHeight: 0 }}>
      <Box sx={{ flexShrink: 0, mb: 0.3 }}>
        <CommentForm />
      </Box>
      <Divider sx={{ my: 0.2 }} />
      <Box sx={{ flex: 1, minHeight: 0 }}>
        <CommentsList />
      </Box>
    </Box>
  )
}
